import { Suspense } from 'react';
import { SellerStatementsClient } from './seller-statements-client';

export const metadata = { title: 'Statements · Seller' };

export default function Page() {
  return (
    <Suspense fallback={null}>
      <SellerStatementsClient />
    </Suspense>
  );
}
